(ns scittle.dataspex
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [dataspex.core]
    [dataspex.hiccup]
    [dataspex.panel]
    [dataspex.ui]
    [dataspex.icons]
    [phosphor.icons]))

;; Plugin: dataspex
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::dataspex
   {:namespaces
   {'dataspex.core (sci/copy-ns dataspex.core (sci/create-ns 'dataspex.core nil))
    'dataspex.hiccup (sci/copy-ns dataspex.hiccup (sci/create-ns 'dataspex.hiccup nil))
    'dataspex.panel (sci/copy-ns dataspex.panel (sci/create-ns 'dataspex.panel nil))
    'dataspex.ui (sci/copy-ns dataspex.ui (sci/create-ns 'dataspex.ui nil))
    'dataspex.icons (sci/copy-ns dataspex.icons (sci/create-ns 'dataspex.icons nil))
    'phosphor.icons (sci/copy-ns phosphor.icons (sci/create-ns 'phosphor.icons nil))}}
   ))
